import { Currency } from '@principle-theorem/accounting';
import {
  DepositPaymentAttemptChannel,
  DepositPaymentAttemptProvider,
  DepositPaymentAttemptStatus,
  DepositPaymentMode,
  type IDepositPaymentAttempt,
  type IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock } from '@principle-theorem/shared';
import { MockDocRef } from '@principle-theorem/testing';

export class PaymentAttemptMock extends BaseFirestoreMock<IDepositPaymentAttempt> {
  practiceRef = MockDocRef<IPractice>();
  provider = DepositPaymentAttemptProvider.Stripe;
  channel = DepositPaymentAttemptChannel.PaymentLink;
  providerAccountId = 'acct_123';
  amountCents = 5000;
  currency: Currency = Currency.AUD;
  paymentMode = DepositPaymentMode.Charge;
  status = DepositPaymentAttemptStatus.AwaitingCustomer;
}
